import { apiClient } from '@/libs/axios';
import {
  toLoginDTO,
  type LoginDTO,
  type LoginPayload,
} from '../schemas/log-in.schema';

export const login = async (data: LoginPayload): Promise<LoginDTO> => {
  const response = await apiClient.post('auth/login', data);

  return toLoginDTO(response);
};
